import * as yup from "yup";
import i18next from "i18next";

const t = (key: string) => i18next.t(key, { ns: "admin" }) as string;

export const vehicleValidation = yup.object().shape({
  brand: yup.string().required(() => t("vehicles.validation.brandRequired")).max(50),
  model: yup.string().required(() => t("vehicles.validation.modelRequired")),
  registerNumber: yup.string()
    .required(() => t("vehicles.validation.registerNumberRequired"))
    .matches(/^([A-Z]{1,3}\s[0-9A-Z]{4,5})+$/, () => t("vehicles.validation.registerNumberFormat"))
    .matches(/^[A-Z]{1,3}.*/, () => t("vehicles.validation.registerNumberLetters"))
    .max(9, () => t("vehicles.validation.registerNumberMaxLength")),
  driver: yup.string().required(() => t("vehicles.validation.driverRequired")),
});